import React from 'react'

export function introTutorial() {
  const steps = [
    {
      target: 'body',
      placement: 'center',
      content: <h2>歡迎來到Keyders</h2>,
    },
    {
      target: '.catChipinputWrapper',
      placement: 'bottom',
      title: '請新增屬性',
      content: (
        <div className="introTutorialContent">
          <p>點選【新增屬性】按鈕，可展開屬性選單，挑選想查詢的分類及職業。</p>
          <p>分類與職業的屬性之間，可選擇要使用聯集(或)或交集(且)的關係。</p>
          <p>本欄為非必填，未輸入屬性，則代表查詢全部屬性。</p>
        </div>
      ),
      styles: {
        options: {
        }
      },
    },
    {
      target: '.chipinput.key',
      placement: 'bottom',
      title: '請輸入關鍵字',
      content: (
        <div className="introTutorialContent">
          <p>輸入關鍵字，可觀測KOL針對指定關鍵字的貼文表現。</p>
          <p>本欄為非必填，未輸入即代表查詢所有貼文。</p>
        </div>
      ),
    },
    {
      target: '.kol_select_source',
      placement: 'bottom',
      title: '請選擇平台',
      content: (
        <div className="introTutorialContent">
          <p>點選想觀測的平台，可複選或單選；查詢結果將依選定之平台顯示各項指標排名。</p>
        </div>
      ),
      // spotlightClicks: true,
    },
    {
      target: '.rangeAndPeriod',
      placement: 'right-start',
      title: '確認粉絲規模及查詢時間',
      // spotlightPadding: 5,
      content: (
        <div className="introTutorialContent">
          <p>輸入欲觀測KOL的粉絲規模，以萬為單位，最小值為0.1，最大值為3000。</p>
          <p>此粉絲人數為查詢平台加總之粉絲數，例如，在前一步驟中，選擇查詢的平台為Facebook + instgram，則粉絲人數為兩平台加總之數字。</p>
        </div>
      ),
    },
    {
      target: '.searchBtn',
      placement: 'left-start',
      content: (
        <div className="introTutorialContent">
          <p>確認所有篩選條件之後，按【搜尋】。</p>
        </div>
      ),
    },
    {
      target: '.kol_select.kol_name',
      placement: 'left-start',
      content: (
        <div className="introTutorialContent">
          <p>若想查詢特定粉專的表現，可直接輸入粉專名稱。輸入部分字串即可，輸入完畢按【搜尋】。</p>
        </div>
      ),
    },
  ]

  return steps;
}


// WEBPACK FOOTER //
// ./src/utility/introTutorial.js